
module dg.objects {
    interface PreExecuteHandler {
        (): ng.IPromise<any>
    }

    export class FormEditorController implements ng.IController {

        public disabled = false;
        public errors = [];
        public form: ng.IFormController;

        private handlersToExecute = new Array<PreExecuteHandler>();
        
        public constructor(
            private $q: ng.IQService) {
        }

        $onInit() {

        }

        public setForm(formCtrl: ng.IFormController) {
            this.form = formCtrl;
        }

        public onPreExecute(handler: PreExecuteHandler) {
            this.handlersToExecute.push(handler);
        }

        public preExecute(): ng.IPromise<any> {

            let promisses = new Array<ng.IPromise<any>>();

            for (let i = 0; i < this.handlersToExecute.length; i++) {
                promisses.push(this.handlersToExecute[i]());
            }

            return this.$q.all(promisses);
        }

        public disable(disabled: boolean) {
            this.disabled = disabled;
        }

        public registerError(error: dg.restfulApi.ErrorResult) {
            // TODO we may throw exception in dg-http-error-handler-interceptor and catch it in app-layout.ts
            this.errors.push(error.data);

            if (error.data.errorType == "Validation") {
                for (let property in error.data.data) {
                    if (this.form[property]) {
                        this.form[property].$invalid = true;
                        this.form[property].$dirty = true;
                        this.form[property].$error.server = error.data.data[property][0];
                    }
                    else {
                        let errorContent = 'Invalid ' + property + ': ' + error.data.data[property][0];
                        this.errors.push(new Error(errorContent));
                    }
                }
            }

            error.data.handeled = true;
        };


        public clearRegisteredErrors() {
            this.errors.length = 0;
        };
    }

    function formEditor(): ng.IDirective {
        return {
            restrict: 'A',
            //scope: {},
            //require: ['^commandInvoker', 'formEditor'],
            controller: FormEditorController,
            //link: (scope, element, attr, ctrls: any) => {
            //    let commandInvokerCtrl = ctrls[0],
            //        formEditorCtrl = ctrls[1];
            //    commandInvokerCtrl.register(formEditorCtrl);
            //}
        };
    }

    angular.module('dg.objects')
        .directive('formEditor', formEditor);
}